export default __webpack_public_path__ + "static/media/inc.776eafc0.jpg";